export default __webpack_public_path__ + "static/media/home-grey.75e28ad3.svg";